import { AuthenticationProvider } from "@/common/providers/authentication";
import { LoaderFunctionArgs, redirect, RouteObject } from "react-router-dom";
import { User } from "../authentication/models/user";
import { LoginRoute } from "../authentication/route";
import ProfileLayoutPage from "./containers/layout";
import ProfileCurrentEntriesPage from "./pages/current-entries";
import ProfileDashboardPage from "./pages/dashboard";
import ProfileManageMembershipPage from "./pages/manage-membership";
import ProfileMembershipDiscountsPage from "./pages/membership-discounts";
import ProfileSettingsPage from "./pages/profile-settings";
import ProfilePurchaseHistoryPage from "./pages/purchase-history";

function layoutLoader({ request }: LoaderFunctionArgs) {
	const user = window.localStorage.getItem("user");

	if (!user) {
		const params = new URLSearchParams();
		params.set("from", new URL(request.url).pathname);
		return redirect(LoginRoute + "?" + params.toString());
	}

	const navUser = JSON.parse(user) as User;

	if (!navUser || !navUser.emailVerified) {
		const params = new URLSearchParams();
		params.set("from", new URL(request.url).pathname);
		return redirect(LoginRoute + "?" + params.toString());
	}

	AuthenticationProvider.signin(navUser);
	return { user: AuthenticationProvider.user };
}

async function membershipDiscountsLoader() {
	try {
		const baseURL = import.meta.env.VITE_SERVER_API_URL;
		const accessToken = AuthenticationProvider?.user?.accessToken;

		const res = await fetch(
			baseURL + "/payments/subscriptions/get-user-active-subscription",
			{
				headers: { Authorization: `Bearer ${accessToken}` },
			}
		);

		const response = await res.json();
		const plan = response.data?.plan;

		if (!plan) {
			return redirect(ProfileDashboardRoute);
		}

		return null;
	} catch {
		return redirect(ProfileDashboardRoute);
	}
}

const ProfileRoute = "/profile";
export const ProfileDashboardRoute = ProfileRoute + "/dashboard";
export const ProfileCurrentEntriesRoute =
	ProfileDashboardRoute + "/current-entries";
export const ProfileMembershipDiscountsRoute =
	ProfileDashboardRoute + "/membership-discounts";
export const ProfilePurchaseHistoryRoute =
	ProfileDashboardRoute + "/purchase-history";
export const ProfileSettingsRoute = ProfileDashboardRoute + "/profile-settings";
export const ProfileManageMembershipRoute =
	ProfileDashboardRoute + "/manage-membership";

const route: RouteObject = {
	path: ProfileRoute,
	loader: layoutLoader,
	Component: ProfileLayoutPage,
	children: [
		{
			path: ProfileDashboardRoute,
			Component: ProfileDashboardPage,
		},
		{
			path: ProfileCurrentEntriesRoute,
			Component: ProfileCurrentEntriesPage,
		},
		{
			path: ProfileMembershipDiscountsRoute,
			Component: ProfileMembershipDiscountsPage,
			loader: membershipDiscountsLoader,
		},
		{
			path: ProfilePurchaseHistoryRoute,
			Component: ProfilePurchaseHistoryPage,
		},
		{
			path: ProfileSettingsRoute,
			Component: ProfileSettingsPage,
		},
		{
			path: ProfileManageMembershipRoute,
			Component: ProfileManageMembershipPage,
		},
	],
};

export default route;
